<template>
  <nav v-if="user">
      <div>
          <p>Hey there {{user.displayName}}</p>
          <p class="email">Currently loged in as ... {{user.email}}</p>
        </div>
      <button @click="handelClick">Logout</button>
  </nav>
</template>

<script>
import useLogout from "../composables/useLogout";
import getUser from "../composables/getUser";

export default {
    setup() {
        const {logout, error} = useLogout()
        const {user} = getUser()

        const handelClick = async () => {
            await logout()

            if (!error.value) {
                console.log('user logged out');
            }
        }

        return {handelClick, user}
    }
}
</script>

<style>
 nav {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  nav p {
    margin: 2px auto;
    font-size: 1.1rem;
    color: #845EC2;
  }
  nav p.email {
    font-size: 14px;
    color: #D65DB1;
  }
</style>